import { getConfig } from '../../../utils/getConfig.ts';
import { MONTH_PLAN, YEAR_PLAN } from '../consts.ts';
import { Plan, PriceID } from '../types.ts';

export const getPlan = (id: PriceID): Plan => {
  const monthID = getConfig('STRIPE_PRICE_MONTHLY');
  const yearID = getConfig('STRIPE_PRICE_YEARLY');

  switch (id) {
    case monthID:
      return { ...MONTH_PLAN, id: monthID };
    case yearID:
      return { ...YEAR_PLAN, id: yearID };
    default:
      throw new Error(`Plan with id ${id} not found`);
  }
};
